import { Select, SelectProps } from "antd";
import { DefaultOptionType } from "antd/es/select";
import { typography } from "theme/Typography";

interface ASelectProps extends SelectProps {
  customized?: boolean;
  loading?:boolean
  // filterOption?: boolean | FilterFunc<DefaultOptionType> | undefined;
}

function ASelect({
  customized,
  children,
  loading,
  ...others
}: ASelectProps) {
  return customized ? (
    <Select
      bordered={false}
      style={{
        borderBottom: "1px solid black",
        fontSize: typography.fontSizes.sm,
      }}
      loading={loading}
      {...others}
    >
      {children}
    </Select>
  ) : (
    <Select bordered={true} {...others} loading={loading}>
      {children}
    </Select>
  );
}

export default ASelect;
